import { color } from './colors';

/**
 * returns a focus state for the current element with border and box-shadow
 */
export const focus = (): string => {
  return `
    box-shadow: 0 0 0 1px ${color.ui_background}, 0 0 0 3px ${color.focus}
  `;
};
